import react from "../../assets/icons/react.svg";
import javascript from "../../assets/icons/javascript.svg";
import html5 from "../../assets/icons/html5.svg";
import wordpress from "../../assets/icons/wordpress.svg";
import etools from "../../assets/icons/etools.svg";
import css from "../../assets/icons/css.svg";

const languages = [
  {
    icon: javascript,
    name: "Javascript",
    level: "65",
  },
  {
    icon: css,
    name: "CSS",
    level: "75",
  },
  {
    icon: html5,
    name: "HTML",
    level: "80",
  },
  {
    icon: react,
    name: "React",
    level: "69",
  },
  {
    icon: react,
    name: "NEXT.js",
    level: "55",
  },
  {
    icon: css,
    name: "Bootstrap",
    level: "60",
  },
  {
    icon: css,
    name: "Material-Ui",
    level: "70",
  },
];

const tools = [
  {
    icon: etools,
    name: "Figma",
    level: "70",
  },
  {
    icon: etools,
    name: "VS Code",
    level: "85",
  },
  {
    icon: etools,
    name: "Cypress",
    level: "85",
  },
  {
    icon: etools,
    name: "Postman",
    level: "85",
  },
  {
    icon: wordpress,
    name: "WordPress",
    level: "80",
  },
];

export { tools, languages };
